export const ERRORS = {
  NO_VALUES_CHANGED:
    'Geben Sie bitte Ihre Änderungen im Eingabebereich an, um das Formular abzusenden.',
  DEFAULT: 'Bitte füllen Sie alle (rotmarkierten) Pflichtfelder aus.',
};
